import { useTranslation } from 'react-i18next'
import React from 'react'

import { useTemplate } from './_load/TemplateLoader'
import Gallery from '../../../components/presentation/gallery/Gallery'
import LabelValue from '../../../components/presentation/LabelValue'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const Details = () => {
  const { t } = useTranslation('templates')
  const template = useTemplate()

  return (
    <>
      <LabelValue label={t('description')} value={template.description} />
      <Separator weight={4} />

      <LabelValue label={t('document')}>
        <Gallery items={[template.document]} colWidth="50%" />
      </LabelValue>
    </>
  )
}

export default Details
